import classNames from 'classnames';

import {OnePaneLayoutFullWidthSectionContent} from '@udemy/react-layout-components';
import {useUDData} from '@udemy/ud-data';

import {TrendingTopicsMenu} from '../topic-category/topic-category-menu.react-component';
import styles from './bfcm-hero.module.less';

export const BfcmHero = ({topicsList}: {topicsList: {name: string; slug: string}[]}) => {
    const {Config} = useUDData();
    const hasMarketPlaceCountry = Config.marketplace_country?.id;
    const subheading = getBfcmHeroSubheading(gettext, hasMarketPlaceCountry);
    return (
        <div className={styles['hero-section']}>
            <div className={styles['hero-section-background']}>
                <OnePaneLayoutFullWidthSectionContent>
                    <div className={styles['hero-section-content']}>
                        <h1 className={styles['hero-section-title']}>
                            {gettext('Udemy Black Friday and Cyber Monday Sale')}
                        </h1>
                        <p
                            className={classNames(styles['hero-section-description'], {
                                [styles['hero-section-subheading-hidden']]: !hasMarketPlaceCountry,
                            })}
                        >
                            {subheading}
                        </p>
                    </div>
                </OnePaneLayoutFullWidthSectionContent>
            </div>
            <TrendingTopicsMenu topicsList={topicsList} />
        </div>
    );
};

export const getBfcmHeroSubheading = (
    gettext: (text: string) => string,
    countryCode: string | undefined,
) => {
    if (countryCode === 'US') {
        return gettext('Get courses starting at $9.99 to help you get ahead in your career.');
    }
    if (countryCode === 'IN') {
        return gettext('Get courses starting at ₹399 to help you get ahead in your career.');
    }
    return gettext('Save big on Udemy courses to help you get ahead in your career.');
};
